// extracted by mini-css-extract-plugin
export var chevron = "_mg-3";
export var chevronRotated = "_mg-4";
export var image = "_mg-1";
export var imageContainer = "_mg-0";
export var shippingAddress = "_mg-2";